module.exports = "images/socialmedia_icon_instagram.svg";